import React from "react"
import { toast } from "react-toastify"
import { FaSave } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { addInventory } from "services"
import { IconButton } from "components"
import classes from "./InventoryRowApplyButton.module.scss"
import clsx from "clsx"

const InventoryRowApplyButton = props => {
  const {
    food,
    option,
    stockIn,
    setStockIn,
    stockOut,
    setStockOut,
    stockManagement,
    setAvailableQuantity,
    sending,
    setSending
  } = props

  const [t, i18n] = useTranslation()

  const validate = () => (
    !!stockIn || !!stockOut
  )

  const handleSave = async () => {
    if (!validate()) return

    setSending(true)

    const quantity =
      Number(stockIn) -
      Number(stockOut)

    try {
      await addInventory(
        food._id,
        option._id,
        {
          branchId: option.branchId,
          quantity
        }
      )

      setStockOut("")

      setStockIn("")

      setAvailableQuantity(prev => prev += quantity)

      toast.success(t("تغییرات_ذخیره_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("تغییرات_ذخیره_نشد"))
    }

    setSending(false)
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <IconButton
      tooltip={t("ذخیره")}
      disabled={!stockManagement}
      icon={FaSave}
      color="white"
      size={16}
      loading={sending}
      onClick={handleSave}
      className={clsx(
        classes["button"],
        isLtr && classes["button-ltr"]
      )}
    />
  )
}

export default InventoryRowApplyButton